declare namespace $ {

	export class $mol_view_tree2_to_js_test_ex_array_inheritance_foo extends $mol_object {
		arr( ): readonly(any)[]
	}
	
	export class $mol_view_tree2_to_js_test_ex_array_inheritance_bar extends $mol_view_tree2_to_js_test_ex_array_inheritance_foo {
		arr( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=array_inheritance.view.tree.d.ts.map